export default {
  rcoHost: '办公桌面云',
  desktopInfo: '桌面信息',
  terminalInfo: '终端信息',
  strategyInfo: '策略信息',
  cloudLogDetail: '云桌面日志查看',
  comingSoon: '敬请期待',
  confirmPws: '请输入您的登录密码',
  rclCloud: '轻云',
  sk: {
    route: {
      webManage: '网站管理',
      articleManage: '文章管理',
      fileManage: '文件管理',
      setting: '基本设置',
      indexSetting: '首页设置',
      innerPageSetting: '内页设置',
      dataAnalysis: '数据分析',
      fileAnalysis: '文件分析',
      contentAnalysis: '内容分析',
      help: '帮助中心',
      softwareManage: '软件管理',
      softwareDictionary: '软件字典',
      softwareList: '软件列表',
      functionAnalysis: '用户分析',
      whitelistManage: '软件白名单',
      activeOrganization: '组织列表',
      characteristicOrganization: '北极星指标'
    },
    navbar: {
      more: '',
      taskLog: '',
      utcSearch: '用户名/终端名称/IP地址',
      accountInfo: '帐号信息',
      updateHeadOffice: '升级总机构',
      alarm: '消息',
      feedBack: '吐个槽',
      alert: '警告',
      about: '关于',
      help: '帮助中心',
      experienceBeta: ''
    }
  },
  treeGroup: {
    root: '总览',
    ad: 'AD域用户组',
    moveToGroup: '指定分组',
    defaultGroup: '未分组',
    deleteTitle: '组删除确认',
    msg: '删除用户组groupName，该组删除后，组下的用户及用户组将移动到指定分组中，请选择指定分组',
    subMsg:
      '注意：如果指定分组是总览，则该用户组下的用户将移动到未分组；如果指定分组是未分组，则该用户组下的所有分组会被删除',
    terminalMsg: '删除终端组groupName，该组删除后，组下的终端及终端组将移动到指定分组中，请选择指定分组',
    terminalSubMsg:
      '注意：如果指定分组是总览，则该终端组下的终端将移动到未分组；如果指定分组是未分组，则该终端组下的所有分组会被删除',
    removeTooltips: '此组下包含其他子组，如需删除，请先以拖拽方式清空子组'
  },
  loading: '加载中...',
  nodata: '暂无数据',
  baseInfo: '基本信息',
  serviceError: {
    403: '没有相关权限',
    500: '服务器内部错误，请稍后重试',
    502: '请求超时，请稍后重试',
    504: '请求超时，请稍后重试'
  },
  customer: '客户',
  partner: '合作伙伴',
  cloudTeam: '云网团队',
  headOffice: '总机构',
  addCustomer: '新增客户',
  joinCustomer: '已有客户',
  addPartner: '新增合作伙伴',
  joinPartner: '已有合作伙伴',
  cloudTeamAdmin: '云网管理员',
  cloudTeamMember: '云网成员',
  headOfficeAdmin: '总机构管理员',
  headOfficeMember: '总机构成员',
  comingSoon2: '功能开发中，敬请期待…',
  noMoreData: '没有更多数据了。',
  back: '返回',
  outMaintain: '退出维护',
  no_auth: '抱歉，您暂无访问权限',
  out: '注销',
  more: '更多>>'
}
